import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCSAProductList, getSerialNoDetails, sendCsaProductSearchValue } from "../../actions/csaApp";
import { withRouter } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import {filterDefault} from '../common/MangoIcons'
import {restFilters, getAllFilters} from '../../actions/filters';


import Filter from './filter-menu'
import SlideToggle from "react-slide-toggle";
import BurgerMenu from './filter-menu';

class ProductSearch extends Component{
    constructor(){
        super()
        this.state = {
            storeFlag: 'TS',
            product_code: null,
            sku_code: null,
            bar_code: null,
            serial_number: null,
            sideBarOption : 'Left',
            barcodeOrSerialNo :'B'
            

        }

        this.validator = new SimpleReactValidator();
    }

    componentDidMount(){
        const { connection_id, store_id } = this.props;
        const category_id = this.props.categoryId;
        const cat_level1 = null;
        const cat_level2 = null;
        const cat_level3 = null;
        const cat_level4 = null;
        const cat_level5 = null;
        const values = ''
        this.props.restFilters();
        const options = {
          connection_id : this.props.connection_id,
          category_id : null,
          gender_id :[],

          category_level_1:cat_level1,
          category_level_2: cat_level2,
          category_level_3 : cat_level3,
          category_level_4 : cat_level4,
          category_level_5: cat_level5,
          
          
    
    
        }
        this.props.getAllFilters(options);
        localStorage.removeItem('optionValue')


    }

    handleChange(event) {
        this.setState({ [event.target.id]: event.target.value });
        if(event.target.id === 'serial_number')
        {
event.target.value !== '' ? this.setState({barcodeOrSerialNo :'S'}) : this.setState({barcodeOrSerialNo :'B'})
        }
        console.log(event.target.id);
    }

    handleScanner = () => {
        if(this.state.storeFlag !== null) {
            localStorage.setItem('csa_storeFlag',this.state.storeFlag)
             localStorage.setItem('barcodeOrSerialNo',this.state.barcodeOrSerialNo)
        this.props.history.push('/csa-scanner')
        }
        else{
            toast.success("Please select the store flag");
        }
    }
   

    getCSAProducts = async(e) => {
        
        const { storeFlag, bar_code, product_code, sku_code  } = this.state;
        const {tenant_details} = this.props;
        console.log(tenant_details && tenant_details.TEN_BUSINESS_CATEGORY_CD,'tenant category')
        const { connection_id, getCSAProductList, success, sendCsaProductSearchValue,store_details,getSerialNoDetails } = this.props;
        e.preventDefault();

        localStorage.removeItem('csa_product_code');
        localStorage.removeItem('csa_storeFlag');
        localStorage.removeItem('csa_sku_id');
        localStorage.removeItem('barcode');
        console.log(this.state.barcodeOrSerialNo )
        var isSerialNo = this.state.barcodeOrSerialNo 
        if(isSerialNo === 'S' ){

             let data = {
        connection_id : this.props.connection_id,
        // product_id : pid,
        tenant_category : tenant_details && tenant_details.TEN_BUSINESS_CATEGORY_CD,

        web_session_id : this.props.web_session_trans_id,
        qty:'1',
        ean:this.state.serial_number,

        RID_CART_ORDER_TYPE :   '',
        ORDER_SUB_TYPE :  '',
         RID_LOT_CD :"",
             RID_FREE_ITEM : "N",
             SCAN_TYPE :"",
             RID_RFID_TAG_SLNO :"",
             RID_SALES_MAN_CODE :"",
             RID_PROCEED_WITH_EAN : "N",
             RID_PROCEED_WITH_GLOBAL_ORDER : null,
             PICKUP_LOC_TYPE :null


      }
        await getSerialNoDetails(data)
        this.props.history.push('/csa-products') 
          
        }


        if(this.state.barcodeOrSerialNo === 'B' && (storeFlag !== null && storeFlag !== '') && ((bar_code !== null && bar_code !== '') || (product_code !== null && product_code !== '') || (sku_code !== null && sku_code !== ''))){
         
            let options = {
                "connection_id": connection_id,
                "product_id": product_code,
                "sku_id":sku_code,
                "barcode":bar_code,
                "store_flag":storeFlag,
                "tenant_name":store_details && store_details.tenant_name,
                "size_id":  [],
                "color_id":  [],
                "brand_code":[],
                "category_id":[],
                "gender_id":[
                   
                ],
               
                "new_arrivals":"",
                "price_start_range":0,
                "price_end_range":9999999,
                
               "page":"",
               "tenant_category" : tenant_details && tenant_details.TEN_BUSINESS_CATEGORY_CD,
                }
        
         localStorage.setItem('optionValue',JSON.stringify(options))
           

         await   getCSAProductList(options)
            sendCsaProductSearchValue(options)
            this.props.history.push('/csa-products') 
                localStorage.setItem('csa_product_code', product_code !== null ? product_code : '' );
                localStorage.setItem('csa_storeFlag', storeFlag !== null ? storeFlag : '' );
                localStorage.setItem('csa_sku_id', sku_code !== null ? sku_code : '');
                localStorage.setItem('barcode', bar_code !== null ? bar_code : '');
        }
        else if(this.state.barcodeOrSerialNo === 'B'){
            if(this.validator.message.length > 1) {
                document.getElementById('error_message').innerHTML = 'Atleast one of the text field value is required to fetch'
                document.getElementById('error_message').style.color='red'
                document.getElementById('error_message').style.paddingBottom='15px'
                //this.validator.showMessages();
                this.forceUpdate();   
            }
           
        }
        
    }

    render(){
        const { sideBarOption, barcodeOrSerialNo } = this.state;
        
        const {tenant_details} = this.props;

        return(
            <React.Fragment>
                <section className="tab-product m-0 " >
                    <div className="csa-product-search ">
                        <div className="container">
                            <div className="container-tab mx-auto">
                                 <div class="row">
                                 <div class="col-md-8 mx-auto">

                                    {/* CSA Product Search Title */}
                                     
                                    <div className="row" style={{ paddingBottom:10}}>
                                        <div className="col text-center" style={{paddingRight:0,paddingLeft:20}}>
                                            <div className="mini-title product-title" style={{display:'block',fontSize:22}}>
                                                <span className="mx-auto">Product Lookup</span>
                                            </div>

                                        </div>
                                        <div className='col' style={{}}>
                                        <BurgerMenu />
                                        
                                        </div>
                                    </div>

                                    {/* CSA Product Search Form */}

                                    <div style={{padding:10}}>

                                    <div className="size-box" style={{ paddingBottom: 10}}>
                                        <div className="col-md-12 col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left !important!", marginBottom: 10 }}>
                                            Product Code
                                        </div>
                                        <div className="col-md-12 col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 15 }}>
                                        <input type="text" className="form-control" id="product_code"
                                            placeholder="Enter Product Code" value={this.state.product_code} onChange={(e) => this.handleChange(e)} />
                                        </div>
                                        {this.validator.message('Product Code', this.state.product_code, 'required')}
                                     </div>

                                     <div className="size-box" style={{ paddingBottom: 10}}>
                                        <div className="col-md-12 col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left", marginBottom: 10 }}>
                                                SKU Code
                                            </div>
                                        <div className="col-md-12 col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 15 }}>
                                        <input type="text" className="form-control" id="sku_code"
                                                placeholder="Enter SKU Code" value={this.state.sku_code} onChange={(e) => this.handleChange(e)} />
                                        </div>
                                        {/* Validation */}
                                        {this.validator.message('SKU Code', this.state.sku_code, 'required')}
                                    </div>
{/* {this.props.store_details && this.props.store_details.tenant_name === 'Goldiam International Limited' ?
                                    <div className="size-box" style={{ paddingBottom: 20}}>
                                        <div className="col-md-12 col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left",  marginBottom: 10, display: 'flex', alignItems: 'center', gap: 20 }}>
                                            <label style={{ marginRight: 15, marginBottom: 0, fontWeight: 500 }}>
                                                <input
                                                    type="radio"
                                                    name="barcodeOrSerialNo"
                                                    value="B"
                                                    checked={this.state.barcodeOrSerialNo === 'B'}
                                                    onChange={() => this.setState({ barcodeOrSerialNo: 'B', bar_code: '' })}
                                                    style={{ marginRight: 5 }}
                                                />
                                                Barcode
                                            </label>
                                            <label style={{ marginBottom: 0, fontWeight: 500 }}>
                                                <input
                                                    type="radio"
                                                    name="barcodeOrSerialNo"
                                                    value="S"
                                                    checked={this.state.barcodeOrSerialNo === 'S'}
                                                    onChange={() => this.setState({ barcodeOrSerialNo: 'S', bar_code: '' })}
                                                    style={{ marginRight: 5 }}
                                                />
                                                Serial Number
                                            </label>
                                        </div>
                                        <div className="col-md-12 col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 15 }}>
                                            <input type="text" className="form-control" id="bar_code"
                                                placeholder={this.state.barcodeOrSerialNo === 'B' ? "Enter Bar Code" : 'Enter Serial No.'} value={this.state.bar_code} onChange={(e) => this.handleChange(e)} />
                                        </div>
                                        {/* Validation */}
                                        {/* {this.validator.message('Bar Code', this.state.bar_code, 'required')} */}
                                    {/* </div> : null }  */}
                                     
                                    <div className="size-box" style={{ paddingBottom: 20}}>
                                        <div className="col-md-12 col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left",  marginBottom: 10 }}>
                                                Barcode
                                            </div>
                                        <div className="col-md-12 col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 15 }}>
                                        <input type="text" className="form-control" id="bar_code"
                                                placeholder="Enter Bar Code" value={this.state.bar_code} onChange={(e) => this.handleChange(e)} />
                                        </div>
                                        {/* Validation */}
                                        {this.validator.message('Bar Code', this.state.bar_code, 'required')}
                                    </div>
    
{tenant_details && tenant_details.TEN_BUSINESS_CATEGORY_CD === 'JEWLLARY' ? 
    <div className="size-box" style={{ paddingBottom: 20}}>
                                        <div className="col-md-12 col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left",  marginBottom: 10 }}>
                                                Serial Number
                                            </div>
                                        <div className="col-md-12 col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 15 }}>
                                        <input type="text" className="form-control" id="serial_number"
                                                placeholder="Enter Serial Number" value={this.state.serial_number} onChange={(e) => this.handleChange(e)} disabled={this.state.storeFlag == 'AL' ? true : false } />
                                        </div>
                                        {/* Validation */}
                                        {this.validator.message('Serial Number', this.state.serial_number, 'required')}
                                    </div> : null }

                                    <div className="size-box" style={{ paddingBottom: 20}}>
                                        <div className="row">
                                            <div className="col-md-6 col-sm-6   col-xs-6">

                                                { this.props.OFN_enabled === 'Y' && this.state.barcodeOrSerialNo ==='B' &&
                                                <div style={{ padding: "10px 0px" }}  >
                                                    <label htmlFor="csaStore" onClick={() => { this.setState({ storeFlag: 'AL' }) }}>
                                                        <input className="radio_animated" type="radio" id="csaStore" name="csaStore" checked={this.state.storeFlag ==='AL'} />
                                                        <span>All Stores</span>
                                                    </label>
                                                </div>
                                                
                                                }
                                                   { this.props.OFN_enabled === 'N' || this.state.barcodeOrSerialNo ==='S'  &&
                                                <div style={{ padding: "10px 0px" }}  >
                                                    <label htmlFor="csaStore" onClick={() => { this.setState({ storeFlag: 'AL' }) }}>
                                                        <input className="radio_animated" type="radio" id="csaStore" name="csaStore" checked={this.state.storeFlag ==='AL'} disabled/>
                                                        <span style={{color:'black'}}>All Stores</span>
                                                    </label>
                                                </div>
                                                
                                                }

                                                <div style={{ padding: "10px 0px" }}  >
                                                    <label htmlFor="csaStore" onClick={() => { this.setState({ storeFlag: 'TS' }) }}>
                                                        <input className="radio_animated" type="radio" id="csaStore" name="csaStore" checked={this.state.storeFlag ==='TS'}/>
                                                        <span style={{color:'black'}}>This Store</span>
                                                    </label>
                                                </div>
                                                {this.validator.message('Store Flag', this.state.storeFlag, 'required')}
                                            </div>
                                            <div className="col-md-5 col-sm-5 col-xs-5 mx-auto text-center">
                                                <button className="btn scanner-btn" onClick={(e) => this.handleScanner(e)} style={{marginTop:'56px',fontSize:'14px'}}>{this.state.barcodeOrSerialNo === 'B' ? 'Scan Barcode' : 'Scan Serial No.'} </button>
                                                {/* <button className="btn btn-solid" type="submit" style={{ marginTop:18}}>Scanner</button> */}
                                            </div>
                                        </div>
                                    </div>
<div id='error_message' style={{color:'red'}}></div>
                                    <div className="size-box" style={{ paddingBottom: 100}}>
                                        <div className="row">
                                            <div className="col-md-2 col-sm-2   col-xs-2 mx-auto">
                                                <button className="btn btn-solid csa-product-btn" type="submit" onClick={(e) => this.getCSAProducts(e)}disabled={this.props.filterLoader}>{this.props.filterLoader ?  'loading...': 'Go'}</button>
                                            </div>
                                        </div>
                                    </div>

                                    </div>
                                
                                  </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                </section>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    OFN_enabled: state.tenant.OFN_enabled,
    connection_id: state.tenant.connection_id,
    success: state.csa.success,
    filterLoader : state.csa.loading,
    store_details: state.tenant.store_details,
    tenant_details: state.tenant.tenant_details,
    web_session_trans_id: state.user.user_details && state.user.web_session_trans_id,

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getCSAProductList, sendCsaProductSearchValue , getAllFilters,getSerialNoDetails,
            restFilters},
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProductSearch));